import { Field } from 'Util/Query';

/** @namespace Query/SmartCardForm */
export class SmartCardQuery {
  getSendSmartCardMutation(options) {
    const mutation = new Field('smartCardInput');
    this._addSendSmartCardMutationArguments(mutation, options);
    mutation.addFieldList(this._getSendSmartCardMutationResponse());
    return mutation;
  }

  _addSendSmartCardMutationArguments(mutation, options) {
    return mutation.addArgument('input', 'SmartCardInput!', options);
  }

  _getSendSmartCardMutationResponse() {
    return ['message'];
  }
}

export default new SmartCardQuery();
